<template>
  <div>
    <sellbuinessdetails :id="business_id"></sellbuinessdetails>
  </div> 
</template>
<script>
import sellbuinessdetails from "@/components/SellBusinessDetails.vue";;
export default {
  components: {
    sellbuinessdetails,
  },
  data () {
    return {
      business_id: 0,
    };
  },
  methods: {
  },
  created () {
    let business_id = this.$route.params.id;
    this.business_id = business_id;
  }

};
</script>
<style scoped>
</style>
